/**
 * Admin page rendered at "/admin/submission-verification" (nested route inside
 * AdminHomepage, mounted at "/admin/*" behind an admin-only ProtectedRoute). Manages
 * the AI submission verification feature via a TabbedPage with four tabs: list ai
 * submissions (AdminListViewContainer), create an ai submission (SubmissionCreatePage),
 * add submission verification training data (TrainingDataCreateDisplay), and browse
 * existing submission verification training data sets.
 */
import AdminListViewContainer from "@/pages/admin/AdminListViewContainer";
import TabbedPage from "@/components/TabbedPage";
import TrainingDataCreateDisplay from "@/pages/admin/ai/TrainingDataCreateDisplay";
import SubmissionCreatePage from "@/pages/submission/SubmissionCreate";

const SubmissionVerificationPage: React.FC = () => {
    return (
        <TabbedPage
            tabs={[
                {
                    tabName: "ai submissions",
                    render: () => (
                        <AdminListViewContainer key="ai-submissions" listItemType="ai_submission" />
                    ),
                },
                {
                    tabName: "create ai submission",
                    render: () => <SubmissionCreatePage type="ai" />,
                },
                {
                    tabName: "add training data",
                    render: () => (
                        <TrainingDataCreateDisplay type="submission_verification" mode="create" />
                    ),
                },
                {
                    tabName: "training data",
                    render: () => (
                        <AdminListViewContainer
                            key="submission-verification-training-data"
                            listItemType="submission_verification_training_data_set"
                        />
                    ),
                },
            ]}
        />
    );
};

export default SubmissionVerificationPage;
